import React from "react";
import { Dialog, DialogContent } from "@mui/material";

interface SCUIGenericDialogProps {
  open: boolean;
  onClose: () => void;
  content: any;
  dialogStyle?: React.CSSProperties;
}

function SCUIGenericDialog({
  open,
  onClose,
  content,
  dialogStyle,
}: SCUIGenericDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} style={dialogStyle}>
      <DialogContent>
        <img
          src={content}
          alt=""
          style={{ width: "250px", height: "auto" }}
        ></img>
      </DialogContent>
    </Dialog>
  );
}
export default SCUIGenericDialog;
